const SESSION_STORAGE_KEY = 'lanternStore';

export default SESSION_STORAGE_KEY;
